export const environment = {
  production: false,
  msalConfig: {
    clientID: 'e7eee2cf-de5c-4612-9c31-ed32ca6d8665',
    authority: 'https://login.microsoftonline.com/afproduct.onmicrosoft.com/',
    cacheLocation: 'localStorage',
    redirectUri: 'http://localhost:4200/',
    postLogoutRedirectUri: 'http://localhost:4200/',
    protectedResourceMap: "https://localhost:44365/",
    consentScopes: ['user.read'],
    resourceScope: 'api://e7eee2cf-de5c-4612-9c31-ed32ca6d8665/user_impersonation',
  },
  parts_service_url: 'https://localhost:44340/api/',
  ADMIN_API_URL: 'https://localhost:44365/api/',
  currentenvironment: 'mg'
};